import './components/global';
import './components/mailing';
import './components/play';
import './components/tween';
